import APP_ICONS from "./icons"

const settingsSubsiderOptions = [
    {
        icon: APP_ICONS.EXAMS_LIST,
        title: "Profile",
        link: "/admin/settings"
    },
    {
        icon: APP_ICONS.EXAMS_LIST,
        title: "Security",
        link: "/admin/settings/security"
    },
    {
        icon: APP_ICONS.EXAMS_LIST,
        title: "Integrations",
        link: "/admin/settings/integrations"
    },
    {
        icon: APP_ICONS.EXAMS_LIST,
        title: "Configurations",
        link: "/admin/settings/configurations"
    },
]

export default settingsSubsiderOptions